export const DEFAULT_CELL_MIN_WIDTH = 110;
export const NUMBER_COLUMN_DEFAULT_WIDTH = 110;
export const DATETIME_COLUMN_DEFAULT_WIDTH = 160;
export const DATE_COLUMN_DEFAULT_WIDTH = 90;
